<template>
    <modal @close="closeContactModal">
        <h3>Get In Touch</h3>
        <div v-if="!response.result" class="large-form">
            <div class="form-line">
                <div class="form-field">
                    <p v-if="data.location=='login'">If you would like to sign up your team, or if you have any questions or issues please fill in the form below and Bookblock HUB team representative will get in touch soon.</p>
                    <p v-if="data.location=='app'">If you have any questions or issues please fill in the form below and your Bookblock HUB Account Manager will get in touch soon.</p>
                </div>
            </div>
            <div class="form-line" v-if="user.id=='0'">
                <div class="form-field">
                    <label>Your Name</label>
                    <input v-model="form.name">
                </div>
                <div class="form-field">
                    <label>Your Email *</label>
                    <input v-model="form.email" required>
                </div>
                <div class="form-field">
                    <label>Phone Number</label>
                    <input v-model="form.phone">
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label>Subject</label>
                    <select v-model="form.subject"  required>
                        <option v-for="o in options" :value="o.id" v-if="o.locations.includes(data.location)">{{ o.name }}</option>
                    </select>
                </div>
            </div>            
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label>Your Message</label>
                    <textarea v-model="form.message" required rows="4"></textarea>
                </div>
             </div>
             
             <div class="modal-errors">
                 <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
             </div>
        </div>
        <div v-if="response.result=='success'" class="large-form">
            <p>Your message has been sent successfully. We will be in touch soon.</p>
        </div>
        <div v-if="response.result=='failure'" class="large-form">
            <p>Unfortunately there has been an error sending your message. Please try again later.</p>
        </div>
        <div class="form-actions">
            <span v-if="!response.result" class="ws-button ws-button-main" data-action="cancel" @click="submitContactModal">SEND</span>
            <span class="ws-button ws-button-secondary" data-action="cancel" @click="closeContactModal">CLOSE</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "ContactModal",
    components: {Modal},
    data() {
        return {
            form: {user_id: null, subject: null, name: null, email: null, phone: null, message: null},
            errors: {},
            response: {result: null, data: null}
        }
    },
    created() {
        this.form.subject = this.data.subject;
        if (!this.form.subject) this.form.subject = 'general';
    },
    methods: {
        async submitContactModal() {
            let fieldsToValidate = [
                { name: 'Subject', value: this.form.subject, rules: ['required'] },
                { name: 'Message', value: this.form.message, rules: ['required'] },
            ];
            if (this.user.id=="0") fieldsToValidate.push({ name: 'Email', value: this.form.email, rules: ['required', 'email'] });
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return;   
            
            this.form.location = this.data.location;
            this.form.subject = this.getFullSubject(this.form.subject);
            this.response = await this.dispatchWaitAndNotify('sendContactForm', this.form);
            console.log(this.response);
            if (this.response.result) {
                this.form.subject = this.form.subject.id;
                this.form.name = null;
                this.form.email = null;
                this.form.phone = null;
                this.form.message = null;
            }
        },
        getFullSubject(sub) {
            for (let i = 0; i!=this.options.length; i++) if (this.options[i].id==sub) return this.options[i];
        },
        closeContactModal() {
            this.response = {result: null, data: null};
            this.modals.contactModal = false;
        },
    },
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        modals() {
            return this.$store.state.modals;
        },
        data() {
            return this.$store.state.contactModalConfig;
        },
        options() {
            return this.$store.state.contactModalOptions;
        }
    },
    watch: { 
       subject: function(subject) { // watch it
         this.form.subject = subject;
       }
     }
}
</script>